import React from 'react';
import './navigationMenu.css';

const NavigationMenu = () => {
    return (
        <header className="sticky-header">
            <div className="container" >
                <div className="logo" onClick={() => {
                    document.getElementById('home').scrollIntoView({ behavior: 'smooth' });
                }} style={{
                    backgroundImage: `url('./assets/imgs/logo.png')`,
                  }}><img src={`${process.env.REACT_APP_PUBLIC_URL}/assets/imgs/logo.png`} alt="Logo" className="img-fluid" id="logoimg"/></div>
                <nav className="nav" id="sticky-header-container">
                    <ul>
                        <li><a id="about-link" onClick={() => {
                            document.getElementById('about').scrollIntoView({ behavior: 'smooth' });
                        }}>Apie</a></li>
                        <li><a id="services-link" onClick={() => {
                            document.getElementById('services').scrollIntoView({ behavior: 'smooth' });
                        }}>Paslaugos</a></li>
                        <li><a id="gallery-link" onClick={() => {
                            document.getElementById('gallery').scrollIntoView({ behavior: 'smooth' });
                        }}>Galerija</a></li>
                        <li><a id="contact-link" onClick={() => {
                            document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
                        }}>Kontaktai</a></li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default NavigationMenu;